// Translations between the camelCase TypeScript shape used in the UI
// and the snake_case column names Postgres uses on the server.
//
// The SQL schema is intentionally 1:1 with the TS types (same fields,
// same semantics, just the case convention differs), so these two
// functions do the full job for every entity.
export function toSnake<T extends Record<string, unknown>>(input: T): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(input)) {
    if (v === undefined) continue;
    out[k.replace(/[A-Z]/g, (m) => "_" + m.toLowerCase())] = v;
  }
  return out;
}

export function fromSnake<T>(input: Record<string, unknown> | null | undefined): T | null {
  if (!input) return null;
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(input)) {
    out[k.replace(/_([a-z])/g, (_, c: string) => c.toUpperCase())] = v;
  }
  return out as T;
}

export function fromSnakeList<T>(rows: Record<string, unknown>[] | null | undefined): T[] {
  if (!rows) return [];
  return rows.map((r) => fromSnake<T>(r) as T);
}
